import {upsert, setFetchingForView, setMetaProp, setView, setCurrent, bulkUpdate, setComplete} from '../../../helpers'

export default {
  setFetchingForView,
  setView,
  setMetaProp,
  setCurrent,
  bulkUpdate,
  upsert,
  setComplete
}



// WEBPACK FOOTER //
// ./src/store/modules/components/mutations.js